import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';

const cor = '#B51013';

export default function VerificarCertificado() {
  const { serial } = useParams();
  const navigate = useNavigate();
  const [resultado, setResultado] = useState(null);
  const [buscando, setBuscando] = useState(true);

  useEffect(() => {
    if (!serial) { setBuscando(false); return; }
    buscarSerial();
  }, [serial]);

  const buscarSerial = async () => {
    try {
      const snap = await getDocs(collection(db, 'progresso'));
      for (const pd of snap.docs) {
        const p = pd.data();
        const trein = p.treinamentos || {};
        for (const [nomeCurso, info] of Object.entries(trein)) {
          if (info.serial === serial) {
            setResultado({ valido: true, nome: p.nome || pd.id, curso: nomeCurso, data: info.concluidoEm, nota: info.nota, serial });
            setBuscando(false);
            return;
          }
        }
      }
      setResultado({ valido: false });
    } catch { setResultado({ valido: false }); }
    setBuscando(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif', padding: '24px' }}>
      <div style={{ maxWidth: '480px', width: '100%' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: cor, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', fontWeight: '900', color: '#fff', margin: '0 auto 12px' }}>J</div>
          <div style={{ fontSize: '18px', fontWeight: '700', letterSpacing: '2px', color: cor }}>JATEAR</div>
          <div style={{ fontSize: '11px', color: '#888' }}>Verificação de Certificado</div>
        </div>

        {buscando ? (
          <div style={{ background: '#fff', borderRadius: '12px', padding: '40px', textAlign: 'center', border: '1px solid #e5e5e5' }}>
            <div style={{ fontSize: '28px', marginBottom: '12px' }}>🔍</div>
            <div style={{ fontSize: '14px', color: '#888' }}>Verificando certificado {serial}...</div>
          </div>
        ) : resultado?.valido ? (
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px', border: '2px solid #1D9E75', boxShadow: '0 4px 20px rgba(29,158,117,0.15)' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '40px', marginBottom: '8px' }}>✅</div>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#1D9E75' }}>Certificado Válido</div>
              <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>Este certificado é autêntico e foi emitido pela Jatear</div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                ['Colaborador', resultado.nome],
                ['Curso', resultado.curso],
                ['Data de conclusão', resultado.data ? new Date(resultado.data).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' }) : '—'],
                ['Nota', resultado.nota || '—'],
                ['Nº do certificado', resultado.serial],
              ].map(([l, v]) => (
                <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 12px', background: '#f9f9f9', borderRadius: '8px', gap: '12px' }}>
                  <span style={{ fontSize: '11px', color: '#888', flexShrink: 0 }}>{l}</span>
                  <span style={{ fontSize: '12px', fontWeight: '500', color: '#1a1a1a', textAlign: 'right' }}>{v}</span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px', border: '2px solid #E24B4A', textAlign: 'center' }}>
            <div style={{ fontSize: '40px', marginBottom: '8px' }}>❌</div>
            <div style={{ fontSize: '16px', fontWeight: '700', color: '#E24B4A', marginBottom: '8px' }}>Certificado Não Encontrado</div>
            <div style={{ fontSize: '13px', color: '#888', lineHeight: '1.6' }}>
              O código <strong>{serial}</strong> não corresponde a nenhum certificado válido em nosso sistema.
              Pode ter sido digitado incorretamente ou o certificado não existe.
            </div>
          </div>
        )}

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button onClick={() => navigate('/')} style={{ padding: '10px 24px', background: 'none', border: `1px solid ${cor}`, color: cor, borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
            Acessar plataforma →
          </button>
        </div>
      </div>
    </div>
  );
}
